import { Component, OnInit, Output, Input, ViewChild, EventEmitter } from '@angular/core';

import { DropdownValue } from './dropdown.model';
import { DropdownComponent } from './dropdown.component';
import { FilterItemsService } from './filter-items.service';

@Component({
    selector: 'publisher-selection',
    template: `<dropdown #selector 
    [values]="publisherValues" 
    [prefix]="publisherPrefix" 
    (valueChange)="onPublisherValueChanged($event)" 
    [useLightClass]="useLightClass"></dropdown>`
})
export class PublisherSelectionComponent implements OnInit {
    publisherValues: Array<DropdownValue> = [];
    defaultPublisherSelection: DropdownValue;
    publisherPrefix: string = "Publisher";

    @Input()
    useLightClass: boolean = false;

    @Input()
    addAllSelection: boolean = false;

    @Output()
    public publisherChange: EventEmitter<DropdownValue> = new EventEmitter<DropdownValue>();;

    @ViewChild("selector") dropdownComponent: DropdownComponent;

    constructor(private filterItemsService: FilterItemsService) {
        this.publisherChange
    }

    ngOnInit() {
        this.setPublishers();
    }

    onPublisherValueChanged(item: DropdownValue) {
        this.publisherChange.emit(item);
    }

    setCurrentSelection(id: number) {
        let publisherValue = this.publisherValues.find(s => s.value === id);
        if (publisherValue)
            this.dropdownComponent.setCurrentSelection(publisherValue);
    }

    getItem(id: number): DropdownValue {
        return this.publisherValues.find(s => s.value === id);
    }

    setFirstItem(): DropdownValue {
        if (this.publisherValues.length > 0) {
            this.dropdownComponent.setCurrentSelection(this.publisherValues[0]);
            return this.publisherValues[0];
        }
        return null;
    }

    loadItems(includeItems: Array<number>) {
        this.publisherValues.splice(0);
        let publishers = this.filterItemsService.getPublishers();
        let sortedItems = publishers.sort((e1, e2) => {
            if (e1.label < e2.label) return -1;
            if (e1.label > e2.label) return 1;
            return 0;
        });
        if (sortedItems.length > 0 && this.addAllSelection)
            this.publisherValues.push(new DropdownValue(0, 'All'));

        if (!includeItems)
            for (var i = 0; i < sortedItems.length; i++)
                this.publisherValues.push(new DropdownValue(sortedItems[i].value, sortedItems[i].label));
        else
            for (var i = 0; i < sortedItems.length; i++)
                if ($.inArray(sortedItems[i].value, includeItems) > -1)
                    this.publisherValues.push(new DropdownValue(sortedItems[i].value, sortedItems[i].label));

        if (this.publisherValues.length > 0)
            this.dropdownComponent.setCurrentSelection(this.publisherValues[0]);
        else
            this.dropdownComponent.setCurrentSelection(null);
    }

    refreshItems(newValue: DropdownValue) {
        this.publisherValues.push(newValue);
    }

    private setPublishers() {
        let publishers = this.filterItemsService.getPublishers();
        let sortedItems = publishers.sort((e1, e2) => {
            if (e1.label < e2.label) return -1;
            if (e1.label > e2.label) return 1;
            return 0;
        });
        if (sortedItems.length > 0 && this.addAllSelection)
            this.publisherValues.push(new DropdownValue(0, 'All'));

        for (let publisher of sortedItems)
            this.publisherValues.push(new DropdownValue(publisher.value, publisher.label));
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/publisher-selection.component.ts